import React, {useState, useEffect} from "react";
import { TextField, Checkbox, FormControlLabel, Typography, Box, Container, Button, MenuItem, FormGroup, Grid, Radio, RadioGroup, FormLabel, FormControl, IconButton } from "@mui/material";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import { Delete, Add } from "@mui/icons-material";
import api from "./api.js";
import Header from "./components/Header.jsx";
import { useConfirmBackLogout } from "./common/useConfirmBackLogout.js";
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import HamburgerMenu from "./components/Hamburger.jsx";

const Comp13Sub = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, setExhibitors}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const [showFormMenu, setShowFormMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [notApply, setNotApply] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [formData, setFormData] = useState({
    user_13_name: "",
    user_13_department: "",
    user_13_phone: "",
    user_13_tel: "",
    extinguisher: '',
    alfa_text: '',
    booth_pathes: [
        {
        safety_path: '',
        },
    ], 
  });

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };


  const [corrections, setCorrections] = useState({
    user_13_info: false,
    booth: false,
  });

  const field_name_map = {
    user_13_info: "担当者情報",
    booth: "ブース平面図情報",
  };

  const [memoText, setMemoText] = useState('');

  const handleCorrectionChange = (fieldKey) => (e) => {
    setCorrections(prev => ({
      ...prev,
      [fieldKey]: e.target.checked
    }));
  };

  const handleCorrection = async () => {
    try {
      // 選択された修正項目を日本語に変換して抽出
      const selectedFields = Object.entries(corrections)
        .filter(([_, checked]) => checked)
        .map(([field]) => field_name_map[field] || field);

      if (selectedFields.length === 0) {
        alert('修正対象の項目を選択してください');
        return;
      }

      const currentPath = window.location.pathname;

      const res = await api.patch('/api/host-correction', {
        exhibitor_id: exhibitorId,
        form_type: 'o13',          // O4固定
        correction: selectedFields, // 日本語に変換した項目
        memo: memoText,
        current_path: currentPath,
      });

      alert('修正リクエスト送信完了');
      setFormModalOpen(false);

      // UIリセット
      setCorrections(Object.fromEntries(Object.keys(corrections).map(k => [k, false])));
      setMemoText('');

    } catch (err) {
      console.error(err);
      alert('修正処理でエラーが発生しました');
    }
  };

  const updateHostStatus = (exhibitorId, formType, newStatus) => {
    setExhibitors((prev) =>
      prev.map((ex) =>
        ex.exhibitor_id === exhibitorId
          ? { ...ex, [`${formType}_host_status`]: newStatus }
          : ex
      )
    );
  };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "host"
      });

      updateHostStatus(exhibitorId, selectedFormKey,'確認済');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "host"
    });
  };

  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);


  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");  

  const handleChange = (e) => {
    const { name, value, type, checked: isChecked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? isChecked : value,
    }));
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  console.log(mypageData)

  const [fieldsDisabled, setFieldsDisabled] = useState(false);

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_13_name: mypageData.user_name || "",
        user_13_department: mypageData.department || "",
        user_13_phone: mypageData.phone_number || "",
        user_13_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_13_name: "",
        user_13_department: "",
        user_13_phone: "",
        user_13_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };

  useEffect(() => {
    const fetchO13InitialData = async () => {
        try {
        const user = JSON.parse(localStorage.getItem("user"));

        const [resStatus, resO13, resMypage] = await Promise.all([
            api.get(`/api/submission-status/${exhibitorId}`),
            api.get(`/api/o13submission/${exhibitorId}`),
            api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o13Status = resStatus.data?.o13_status || "";
        const o13Data = resO13.data || {};
        const mypage = resMypage.data || {};

        if (o13Status === "申請しない") {
            setNotApply(true);
            setFormData({
            user_13_name: null,
            user_13_department: null,
            user_13_phone: null,
            user_13_tel: null,
            alfa_text: null,
            booth_pathes: [],          
            });
        } else {
            if (Object.values(o13Data).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
            })) {
            setFormData(prev => ({
                ...prev,
                ...o13Data,
                booth_pathes: o13Data.booth_pathes || [],
            }));
            if (
              o13Data.user_13_name === mypage.user_name &&
              o13Data.user_13_department === mypage.department &&
              o13Data.user_13_phone === mypage.phone_number &&
              o13Data.user_13_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }
            }

            setNotApply(false);
        }

        } catch (err) {
        console.error("O13初期データ取得エラー:", err);
        }
    };

    fetchO13InitialData();
    }, []);

  useEffect(() => {
    const fetchPreviewUrls = async () => {
      const validFiles = formData.booth_pathes.filter(
        (file) => file?.safety_path && file.safety_path.includes("/")
      );

      const previews = await Promise.all(
        validFiles.map(async (file) => {
          const parts = file.safety_path.split("/");

          // 想定形式: o13/{exhibitorId}/{filename}
          if (parts.length < 3) {
            console.warn("不正なsafety_path:", file.safety_path);
            return null;
          }

          const exhibitorId = parts[1];
          const filename = parts[parts.length - 1];

          try {
            const res = await api.get(
              `/api/files/o13/${exhibitorId}/${filename}?t=${Date.now()}`,
              { responseType: "blob" }
            );

            const url = URL.createObjectURL(res.data);

            return {
              ...file,
              previewUrl: url,
              mimeType: res.data.type,
              name: filename,
            };
          } catch (err) {
            console.error("ファイル取得失敗:", err);
            return {
              ...file,
              previewUrl: null,
              mimeType: null,
              name: filename,
            };
          }
        })
      );

      setPreviewFiles(previews.filter(Boolean)); // null除去
    };

    if (!Array.isArray(formData.booth_pathes) || formData.booth_pathes.length === 0) {
      setPreviewFiles([]);
      return;
    }

    fetchPreviewUrls();
  }, [formData.booth_pathes]);


  const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
            user_13_name: "",
            user_13_department: "",
            user_13_phone: "",
            user_13_tel: "",
            extinguisher: null,
            alfa_text: null,
            alchol_details: [],
            fire_details: [],
            flame_details: [],
            gas_details: [],
            oil_details: [],
            booth_pathes: [], 
          });
      }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };  
  
    const [isHovered, setIsHovered] = useState(false);
  
    const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者用追加パス', path: '/出展者用追加パス.pdf' },
      { label: '小間図面', path: '/小間図面.pdf' },
      { label: '素材集', path: '/素材集.zip' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];
  
    const renderMenuItems = () => (
      <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
      >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
          <div className="submenu">
              {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
              </a>
              ))}
          </div>
          )}
      </div>
    );

    const handleFileChange = async (e) => {
      const files = Array.from(e.target.files);
      if (!files.length) return;

      setUploading(true);

      const formDataObj = new FormData();
      files.forEach((file) => {
        formDataObj.append("files", file);
      });

      try {
        const res = await api.post(`/api/upload-booth/${exhibitorId}`, formDataObj, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const newPaths = res.data.paths.map((path) => ({ safety_path: path }));

        // アップロード後にプレビュー画像を取得
        const newPreviews = await Promise.all(
          res.data.paths.map(async (path) => {
            const exhibitorId = path.split("/")[1]; // 例: "1"
            const filename = path.split("/").pop(); // 例: "5.jpg"

            try {
              const res = await api.get(`/api/files/o13/${exhibitorId}/${filename}?t=${Date.now()}`, {
                responseType: "blob",
              });

              const url = URL.createObjectURL(res.data);
              return {
                safety_path: path,
                previewUrl: url,
                mimeType: res.data.type,
                name: filename,
              };
            } catch (err) {
              console.error("ファイル取得失敗:", err);
              return {
                safety_path: path,
                previewUrl: null,
                mimeType: null,
                name: null,
              };
            }
          })
        );

        // booth_pathes と previewFiles を更新
        setFormData((prev) => {
          const newPathsAll = [...(prev.booth_pathes || []), ...newPaths];

          // 🔑 safety_path でユニーク化
          const uniquePaths = newPathsAll.filter(
            (p, idx, arr) => idx === arr.findIndex(q => q.safety_path === p.safety_path)
          );

          return {
            ...prev,
            booth_pathes: uniquePaths,
          };
        });

        setPreviewFiles((prev) => {
          const newPreviewsAll = [...prev, ...newPreviews];

          // 🔑 safety_path でユニーク化（プレビューも同じように）
          const uniquePreviews = newPreviewsAll.filter(
            (p, idx, arr) => idx === arr.findIndex(q => q.safety_path === p.safety_path)
          );

          return uniquePreviews;
        });
      } catch (err) {
        console.error("アップロード失敗", err);
        alert("アップロードに失敗しました。");
      } finally {
        setUploading(false);
        e.target.value = null;
      }
    };

  const handleDeleteFile = async (indexToDelete) => {
    const pathToDelete = formData.booth_pathes[indexToDelete].safety_path;
    try {
      await api.delete("/api/delete-booth", { data: { path: pathToDelete } });

      // formData.booth_pathes のみ更新（これをトリガーに useEffect で previewFiles が更新される）
      setFormData((prev) => ({
        ...prev,
        booth_pathes: prev.booth_pathes.filter((_, idx) => idx !== indexToDelete),
      }));
    } catch (err) {
      console.error("削除失敗", err);
      alert("削除に失敗しました。");
    }
  };

  const [statusData, setStatusData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res2 = await api.get(`/api/submission-status/${user.mypage_id}`);
        setStatusData(res2.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);
  const user = JSON.parse(localStorage.getItem("user"));

  const isBoothRequiredByStatus = statusData && ["o5_status","o7_status","o9_status","o11_status"]
    .some(key => statusData[key] === "提出済み");

  const isBoothRequiredByUser = user?.co_exhibit === true && user?.user_id === 0;

  // ファイルアップロードの必須チェック用
  const isBoothRequired = isBoothRequiredByStatus || isBoothRequiredByUser;

  const [submitErrors, setSubmitErrors] = useState({});

    const handleSubmit = async () => {
      try {
        if (!exhibitorId || typeof exhibitorId !== "number") {
          alert("exhibitorId が不正です");
          return;
        }

        const submitErrors = {};

        // if (isBoothRequired && previewFiles.length === 0) {
        //   if (isBoothRequiredByUser) {
        //     submitErrors.booth_upload = "共同出展のため、子企業の配置図を含めた、ブース平面図のアップロードが必須です。";
        //   }
        // }

        if (!notApply) {
          if (!formData.user_13_name?.trim()) submitErrors.user_13_name = "入力してください";
          if (!formData.user_13_phone?.trim()) submitErrors.user_13_phone = "入力してください";
          if (!formData.user_13_tel?.trim()) submitErrors.user_13_tel = "入力してください";
        }

        const fieldDisplayNames = {
          user_13_name: "担当者名",
          user_13_phone: "担当者携帯",
          user_13_tel: "担当者電話",
          booth_upload: "ブース平面図"
        };

        // エラーがあればリターン
        if (Object.keys(submitErrors).length > 0) {
          setSubmitErrors(submitErrors);
          window.scrollTo({ top: 0, behavior: "smooth" });

          const errorMessages = Object.entries(submitErrors)
            .map(([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`)
            .join("\n");

          alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
          return;
        }

        const payload = {
          exhibitor_id: exhibitorId,
          formData: formData,
          notApply: notApply,
        };

        // API 分岐
        let endpoint = "/api/submit-o13";
        if (mypageData?.user_id === 0 && mypageData?.parent_exhibit === false) {
          endpoint = "/api/submit/parent";
        }

        const res = await api.post(endpoint, payload);

        if (res.status === 200) {
          alert("保存成功");
        } else {
          alert("保存失敗");
        }

        setTimeout(() => {
          if (isModal) {
            setFormModalOpen(false);
          } else {
            if (mypageData?.user_id === 0) {
              navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
            } else {
              navigate(`/mypage/${user?.mypage_id}`);
            }
          }
        }, 1000);
      } catch (err) {
        console.error(err);
        alert("エラー");
      }
    };
  const baseUrl =
  window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8000'          // ローカル開発用
    : 'https://sdgs.ex-link.net'; // 本番 HTTPS

    useConfirmBackLogout(navigate);
    useNavigationHistory();

  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="SDGs 子ども・ユースフェア2026 ブース平面図申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }}>
        {!isCorpModal &&(
        <>
        <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #00131BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#00131bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Typography variant="h6" gutterBottom>
              修正内容のメモ
            </Typography>
            <TextField
              multiline
              rows={20}
              fullWidth
              placeholder="ここに修正内容を書いてください..."
              value={memoText}
              onChange={(e) => setMemoText(e.target.value)}
            />
            <Box>
              <Typography variant="h6">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{ width: {xs:'100%',md: '80%'}, mt:4, pb:'30px' }}>
        <Typography variant="h6">ブース平面図</Typography>
        <FormGroup sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
            <FormControlLabel
            control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
            label="申請しない"
            />

            {!notApply && (
            <>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.user_13_info}
                        onChange={handleCorrectionChange( 'user_13_info')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="担当者情報"
                  />
                )}
                <Typography variant="h6" gutterBottom>
                担当者情報
                </Typography>
                <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                </FormControl>
                <Grid container spacing={2}>
                <Grid size={6}><TextField fullWidth label="氏名" name="user_13_name" value={formData.user_13_name} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_13_name} helperText={submitErrors.user_13_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="部署" name="user_13_department" value={formData.user_13_department} disabled={fieldsDisabled} onChange={handleChange} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_13_phone" value={formData.user_13_phone} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_13_phone} helperText={submitErrors.user_13_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_13_tel" value={formData.user_13_tel} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_13_tel} helperText={submitErrors.user_13_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                </Grid>
                <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>
             
                <Box>
                  {!!changeModalOpen &&(
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={corrections.booth}
                          onChange={handleCorrectionChange( 'booth')}
                          sx={{
                      color: 'red', // 未チェック時の枠の色
                      '&.Mui-checked': {
                        color: 'red', // チェック時の色
                      },
                    }}
                        />
                      }
                      label="ブース平面図情報"
                    />
                  )}
                  <Typography variant="h6" gutterBottom>ブース平面図アップロード</Typography>
                  
                  {isBoothRequiredByStatus && (
                    <Typography color="error">※ブース平面図のアップロードが必要です</Typography>
                  )}
                  {/* {isBoothRequiredByUser && (
                    <Typography color="error">※共同出展のため、子会社の配置を含むアップロードが必要です</Typography>
                  )} */}

                  <Button variant="contained" color="primary" href="/ブース平面図_フォーマット.pdf" download>フォーマットをダウンロードする</Button>

                  <Typography gutterBottom color="error">※上記フォーマットへブースレイアウトを記入の上、ご提出ください。自社で作成した図面の提出も可能です。</Typography>

                  <Typography gutterBottom color="error">※PDFもしくはJPEGデータにてご申請ください。</Typography>

                  <input
                    type="file"
                    id="booth-upload"
                    multiple
                    accept=".pdf,.jpg,.jpeg,.png,.webp"
                    onChange={handleFileChange}
                    disabled={uploading}
                  />

                  <div style={{ marginTop: "1rem" }}>
                    <Typography variant="subtitle2">画像はクリックで拡大できます。</Typography>
                    {previewFiles.length === 0 ? <p>まずアップロードして下さい。</p> : (
                      previewFiles.map((file, idx) => (
                        <div key={idx} style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "0.5rem" }}>
                          {file.previewUrl && file.mimeType?.startsWith("image/") ? (
                            <img
                              src={file.previewUrl}
                              alt="preview"
                              onClick={(e) => e.target.classList.toggle("zoomed")}
                              style={{ width: 100, height: "auto", cursor: "zoom-in", transition: "transform 0.3s ease" }}
                              className="zoom-image"
                            />
                          ) : file.previewUrl && file.mimeType === "application/pdf" ? (
                            <a href={`${baseUrl}/api/get-booth/${exhibitorId}/${file.name}`} target="_blank" rel="noopener noreferrer">
                              PDFを別タブで開いて確認
                            </a>
                          ) : (
                            <a href={file.previewUrl} target="_blank" rel="noopener noreferrer">
                              {file.safety_path.split("/").pop()}
                            </a>
                          )}
                          {!isCorpModal &&(
                          <IconButton onClick={() => handleDeleteFile(idx)}><Delete /></IconButton>
                          )}
                        </div>
                      ))
                    )}
                  </div>
                </Box>
                <Typography variant="h6">備考欄</Typography>
                <Typography color="error">※ブース平面図について補足事項等がある場合はコチラにご入力ください。</Typography>
                <TextField fullWidth multiline rows={8} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
            </Box>
            </>
            )}
        </FormGroup>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
          <Typography>
            【上記入力内容についてのお問い合わせ先】<br />
            SDGs 子ども・ユースフェア出展者事務局（中部経済新聞社　事業部内）<br />
            担当：佐野・三宅<br />
            TEL:052-561-5675<br />
            入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
            ※お急ぎの場合はお電話にてお問い合わせください。
          </Typography>
        </Box>
        </Container>
      </Container>
      {!isCorpModal &&(
        <>
        <Container sx={{textAlign: 'center'}}>
            <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                提出する
            </Button>
        </Container>
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
       </>
      )}
      {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button 
          variant="contained" 
          color="error" 
          onClick={handleCorrection}
          disabled={memoText.trim() === ''}
        >
          修正
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          確認
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
  );
};

export default Comp13Sub;